import { motion } from 'framer-motion';

const PageTransition = ({ children }) => {
  return (
    <>
      {/* Exit Wipe (Charcoal) - moves up from bottom */}
      <motion.div
        className="page-wipe"
        initial={{ height: 0 }}
        animate={{ height: 0 }}
        exit={{ height: '100vh' }}
        transition={{ duration: 0.6, ease: [0.77, 0, 0.175, 1] }}
        style={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          width: '100%',
          backgroundColor: '#1A1208',
          zIndex: 9999,
          overflow: 'hidden'
        }}
      >
        <div style={{ position: 'absolute', bottom: 0, left: 0, width: '100%', height: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', color: '#D4700A' }}>
          <div style={{ width: '100px', height: '100px', marginBottom: '1.5rem' }}>
            <svg viewBox="0 0 40 40" fill="none">
              <circle cx="20" cy="20" r="18" stroke="currentColor" strokeWidth="1" opacity="0.4"/>
              <path d="M20 8 C20 8, 28 14, 28 22 C28 30, 20 34, 20 34 C20 34, 12 30, 12 22 C12 14, 20 8, 20 8Z" fill="currentColor" opacity="0.15"/>
              <circle cx="20" cy="20" r="4" fill="currentColor"/>
              <path d="M20 12 L20 8 M20 32 L20 28 M12 20 L8 20 M32 20 L28 20" stroke="currentColor" strokeWidth="1" opacity="0.6"/>
            </svg>
          </div>
        </div>
      </motion.div>

      {/* Enter Wipe (Orange) - moves up towards top */}
      <motion.div
        className="page-wipe-in"
        initial={{ height: '100vh' }}
        animate={{ height: 0 }}
        exit={{ height: 0 }}
        transition={{ duration: 0.6, ease: [0.77, 0, 0.175, 1], delay: 0.1 }}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          backgroundColor: '#D4700A',
          zIndex: 9998,
          overflow: 'hidden',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', color: '#FFF', pointerEvents: 'none' }}>
          <div style={{ width: '120px', height: '120px', marginBottom: '2rem' }}>
            <svg viewBox="0 0 40 40" fill="none">
              <circle cx="20" cy="20" r="18" stroke="currentColor" strokeWidth="1" opacity="0.4"/>
              <path d="M20 8 C20 8, 28 14, 28 22 C28 30, 20 34, 20 34 C20 34, 12 30, 12 22 C12 14, 20 8, 20 8Z" fill="currentColor" opacity="0.2"/>
              <circle cx="20" cy="20" r="4" fill="currentColor"/>
              <path d="M20 12 L20 8 M20 32 L20 28 M12 20 L8 20 M32 20 L28 20" stroke="currentColor" strokeWidth="1" opacity="0.8"/>
            </svg>
          </div>
          <div style={{ textAlign: 'center', display: 'flex', flexDirection: 'column', lineHeight: 1 }}>
            <span style={{ fontFamily: 'var(--font-display)', fontWeight: 900, fontSize: '4.5rem', letterSpacing: '-0.02em' }}>Ragini</span>
            <span style={{ fontFamily: 'var(--font-sans)', fontSize: '1.2rem', fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.3em', marginTop: '12px' }}>Masale</span>
          </div>
        </div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.5, ease: [0.4, 0, 0.2, 1] }}
      >
        {children}
      </motion.div>
    </>
  );
};

export default PageTransition;
